import { ignoreError } from '~/infra/ignoreError';
import { LoginMethod } from './loginMethod';
export const PENDING_LOGIN_METHOD_KEY = 'anchor.pendingLoginMethod.v1';
export const PENDING_LOGIN_METHOD_TTL_MS = 10 * 60000;
const LOGIN_METHODS = Object.values(LoginMethod);
const toLoginMethod = (value)=>{
    var _LOGIN_METHODS_find;
    return (_LOGIN_METHODS_find = LOGIN_METHODS.find((method)=>method === value)) !== null && _LOGIN_METHODS_find !== void 0 ? _LOGIN_METHODS_find : null;
};
const parseEntry = (raw)=>{
    if (raw == null) return null;
    try {
        const { method, atMs } = JSON.parse(raw);
        const loginMethod = toLoginMethod(method);
        return loginMethod != null && typeof atMs === 'number' ? {
            method: loginMethod,
            atMs
        } : null;
    } catch (unused) {
        return null;
    }
};
export const makePendingLoginMethodStorage = (storage, getNow)=>{
    // WHY: storage throws in private browsing and with site data blocked, and this only observes the sign-in.
    const clearPendingMethod = ()=>{
        ignoreError(()=>storage.removeItem(PENDING_LOGIN_METHOD_KEY));
    };
    return {
        persistPendingMethod: (method)=>{
            ignoreError(()=>storage.setItem(PENDING_LOGIN_METHOD_KEY, JSON.stringify({
                    method,
                    atMs: getNow().getTime()
                })));
        },
        readPendingMethod: ()=>{
            const entry = parseEntry(ignoreError(()=>storage.getItem(PENDING_LOGIN_METHOD_KEY)));
            if (entry == null) return null;
            if (getNow().getTime() - entry.atMs < PENDING_LOGIN_METHOD_TTL_MS) return entry.method;
            clearPendingMethod();
            return null;
        },
        clearPendingMethod
    };
};
